<template>
  <div class="text-left p-1">
    <span class="mr-3">{{ displayName(varItem) }}</span>
    <setter :var-item="varItem" />
    <hr />
  </div>
</template>

<script>
import Setter from '@/components/logging/settings/Setter';
import { mapState } from 'vuex';


export default {
  name: 'Item',
  components: { Setter },
  props: {
    varItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
  },
  methods: {
    displayName(varItem) {
      const actorName = this.currentSnapshot.rev === 2 ? varItem.actorsTitle : varItem.actorsName;
      const varName = this.currentSnapshot.rev === 2 ? varItem.title : varItem.description;

      const useVarName = this.currentSnapshot.rev === 2 || varItem.link.includes(varItem.actorsName);

      return useVarName ? varName : actorName;
    },
  },
};
</script>

<style scoped>

</style>
